import { Box } from "@mui/material";

export default function CustomPagination({ page, pageCount, onPageChange }) {
  const getPageNumbers = () => {
    const pages = [];

    if (pageCount <= 7) {
      for (let i = 0; i < pageCount; i++) {
        pages.push(i);
      }
    } else {
      if (page < 2) {
        for (let i = 0; i < 3; i++) {
          pages.push(i);
        }
        pages.push("...");
        pages.push(pageCount - 1, pageCount - 2, pageCount - 3);
      } else if (page >= pageCount - 2) {
        pages.push(0);
        pages.push("...");
        for (let i = pageCount - 3; i < pageCount; i++) {
          pages.push(i);
        }
      } else {
        pages.push(0);
        pages.push("...");

        for (let i = page - 1; i <= page + 1; i++) {
          pages.push(i);
        }

        pages.push("...");
        pages.push(pageCount - 1);
      }
    }

    return pages;
  };

  const handlePageChange = (newPage) => {
    if (newPage < 0 || newPage >= pageCount) return;
    onPageChange(newPage);
  };

  return (
    <Box className="flex items-center justify-between w-full h-full">
      <button
        onClick={() => handlePageChange(page - 1)}
        disabled={page === 0}
        className={`${
          page === 0 ? "opacity-50" : "hover:bg-lightBrown cursor-pointer"
        } flex rounded-none px-4 py-3`}
      >
        <span className="rotate-180 content-paginatorDarkArrowRightIcon w-[20px] h-[20px]"></span>
        <span className="text-primaryBlue ml-[4px] text-sm font-semibold">
          Previous
        </span>
      </button>

      <Box className="flex items-end gap-1">
        {getPageNumbers().map((pageNum, idx) =>
          pageNum === "..." ? (
            <span
              key={`ellipsis-${idx}`}
              className="px-4 py-3 text-sm font-semibold text-primaryBlue"
            >
              ...
            </span>
          ) : (
            <button
              key={pageNum}
              onClick={() => handlePageChange(pageNum)}
              className={`${
                pageNum === page ? "bg-lightBrown" : ""
              } px-4 py-3 text-sm font-semibold cursor-pointer text-primaryBlue hover:bg-lightBrown`}
            >
              <span className="text-sm font-semibold text-primaryBlue">
                {pageNum + 1}
              </span>
            </button>
          ),
        )}
      </Box>

      <button
        onClick={() => handlePageChange(page + 1)}
        disabled={page >= pageCount - 1}
        className={`${
          page >= pageCount - 1
            ? "opacity-50"
            : "hover:bg-lightBrown cursor-pointer"
        } flex rounded-none px-4 py-3`}
      >
        <span className="text-primaryBlue mr-[4px] text-sm font-semibold">
          Next
        </span>
        <a className="content-paginatorDarkArrowRightIcon w-[20px] h-[20px]"></a>
      </button>
    </Box>
  );
}
